module.exports = __webpack_public_path__ + "img/box3_img2.4afa70a1.png";